export default __webpack_public_path__ + "static/media/lost-icon.dfc6b8a4.svg";